import { Pipe, PipeTransform } from '@angular/core';

/**
 * Add URL protocol if the given url doesn't have it
 * URL protocol could prevent user to go Angular route
 */

@Pipe({
  name: 'linkProtocol',
})
export class LinkProtocolPipe implements PipeTransform {
  transform(url: string): any {
    if (!/^https?:\/\//i.test(url)) {
      return `https://${url}`;
    }

    return url;
  }
}
